

exports.__esModule = true;

var _angular = require('angular');

var _index = require('squid/index');

var _index2 = require('xo-device-info/dist/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index3 = require('xo-models/src/checkout/index');

var _index4 = require('xo-models/src/user/index');

var _index5 = require('xo-models/src/auth/index');

var _index6 = require('xo-models/src/prox/index');

var _index7 = require('xo-models/src/profilemanagement/index');

var _index8 = require('xo-return-to-merchant/dist/index');

var _returnParams = require('xo-page-components/src/returnParams');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoEnd', {

    tag: 'xo-end',

    template: _template2['default'],

    props: {},

    resolve: {
        models: function models() {
            return {
                payee: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutSession: _index3.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()
            };
        },
        dependentModels: function dependentModels(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    merchantPreferences: _index7.$MerchantPreferenceModel.instance(models.payee.merchant.id).retrieve()
                };
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            angular.element('#outerWrapper').addClass('xo-end');
            _angular.$rootScope.$emit('startLoad');
        },
        exit: function exit() {
            // If there is any error in this directive, then we need to hide spinner
            // so that when user reaches generic error page, he can return to merchant
            // by clicking on "return to merchant" button
            _angular.$rootScope.$emit('allLoaded');
        },
        populate: function populate() {
            var _this = this;

            function returnMethod(merchantPreferences) {
                if (merchantPreferences) {
                    return merchantPreferences.returnMethod();
                }
                return 'GET';
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                if (checkoutAppData.is_wps_flow() && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                } else {
                    return checkoutAppData.urls.return_url;
                }
            }

            function postToMerchant(wpsURL, wpsData) {
                _index8.$ReturnToMerchant.postTo(wpsURL, wpsData);
            }

            var goToMerchant = function goToMerchant(wpsURL, wpsData) {
                // if PDT is disabled don't send params in the url
                if (_this.dependentModels.merchantPreferences && !_this.dependentModels.merchantPreferences.pdtEnabled()) {
                    return _index8.$ReturnToMerchant.goTo(wpsURL);
                }
                return _index8.$ReturnToMerchant.goTo(_index.$util.buildURL(wpsURL, wpsData));
            };

            _angular.$q.when().then(function () {

                /*
                    If we're in an in-context flow, the parent button
                    iframe may need the access token to continue running
                    and execute the payment (e.g. in 3rd party cookies
                    disabled mode)
                     We reload the auth model, since after the user is
                    onboarded this model is not updated, then pass the
                    access token up. The token will only be passed if
                    we're on the same-domain as the parent button.
                */

                if (window.xprops && window.xprops.onAuth) {
                    var auth = _index5.$AuthModel.instance();

                    return auth.reload().then(function () {
                        window.xprops.onAuth({ accessToken: auth.access_token });
                    });
                }
            }).then(function () {

                // handle the return url with post and get , with and without PDT for WPS alone
                // PDT - Payment Data Transfer
                if (_this.models.checkoutAppData.is_wps_flow()) {
                    var wpsURL = returnUrl(_this.models.checkoutAppData, _this.dependentModels.merchantPreferences);
                    var returnToMerchantMethod = returnMethod(_this.dependentModels.merchantPreferences);
                    var isWPSCart = _this.models.checkoutAppData.flags.is_cart_upload_flow || _this.models.checkoutAppData.flags.is_shopping_cart_flow;
                    var wpsParams = (0, _returnParams.$returnParams)(_this.models.checkoutCart, _this.models.checkoutSession, returnToMerchantMethod, 'WPS', isWPSCart);

                    return returnToMerchantMethod === 'POST' ? postToMerchant(wpsURL, wpsParams) : goToMerchant(wpsURL, wpsParams);
                }

                var params = {};
                // Creating the checkoutInputData here so that it would not make payer-id call.
                var checkoutInputData = _index4.$CheckoutInputDataModel.instance(_angular.$rootScope.token);

                // Don't post PayerID for RT without purchase
                if (!_this.models.checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = _this.models.checkoutSession.payer.id;
                }

                var billingData = _this.models.checkoutCart.billing;

                // exclude BA token in the returnUrl for external merchant - (merchant not calling BEAM directly)
                if (billingData && billingData.ba_token && !_this.models.checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                // When "redirect_uri" is passed as a query param
                if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
                    params.return_uri = _this.models.checkoutAppData.urls.return_url ? _index.$util.buildURL(_this.models.checkoutAppData.urls.return_url, params) : null;

                    // Add these params after building `return_uri` to ensure they are not added into the final url
                    params.intent = _this.models.checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.paymentId = _this.models.checkoutAppData.payment_id;
                    params.token = _angular.$rootScope.token;
                }

                var handleRedirection = function handleRedirection(url) {
                    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
                    var isMobileDevice = Boolean(_index2.$DeviceInfo.isDevice() && !isHTTPUrl);

                    /* Webview to App view switching is not happening properly
                    * so to handle , adding a work around by adding cancel / return to merchant url
                    * on success page
                    * routeToComplete is the route which shows cancel / return to merchant url*/
                    if (isMobileDevice) {
                        _logger.$logger.info('Switching_Webview_To_App_view', {
                            url: url
                        });
                        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {
                            // leave this blank , having this comment for lint warning - Unexpected Empty Function
                        };
                        _angular.$window.location = url;

                        return _uiRouter.$state.go('checkout.routeToComplete', {
                            url: url,
                            urlType: 'success'
                        });
                    } else {
                        _index8.$ReturnToMerchant.goTo(url);
                    }

                    return _index.$unresolved;
                };

                function finishProxFlow() {
                    // for Prox Signup flow (eBay), generate auth code
                    var auth = _index5.$AuthModel.instance();

                    _logger.$logger.info('prox_exit_login_code_start');

                    return auth.action('loginCode', {
                        data: {
                            user: {},
                            client: {
                                client_id: _index.$config.proxStsClientId,
                                redirect_uri: checkoutInputData.redirect_uri,
                                scope: checkoutInputData.scope,
                                id_token: '',
                                nonce: auth.nonce,
                                response_type: 'code',
                                skip_oauth: false,
                                skip_consent: true,
                                target_client_id: _index.$util.base64Decode(checkoutInputData.client_id),
                                visitor_id: auth.visitor_id,
                                scope_consent_context: 'access_token'
                            }
                        }

                    })['catch'](function (err) {
                        _logger.$logger.error('prox_exit_login_code_error', err);
                        _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl(err.message));

                        return _index.$unresolved;
                    }).then(function (loginCodeResult) {
                        if (loginCodeResult && loginCodeResult.data && loginCodeResult.data.code) {
                            _logger.$logger.info('prox_exit_login_code_success');
                            return handleRedirection(checkoutInputData.successUrl(loginCodeResult.data.code));
                        } else {
                            _logger.$logger.error('prox_exit_login_code_not_found');
                            _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl('auth_code_error'));

                            return _index.$unresolved;
                        }
                    });
                }

                if (!checkoutInputData.isEbayTxn()) {
                    // non-Ebay/xoon flow
                    return _angular.$q.when().then(function () {
                        if (window.xprops && window.xprops.onAuthorize) {
                            _logger.$logger.done();
                            _angular.$rootScope.$emit('loading');

                            var xparams = {
                                paymentToken: _angular.$rootScope.token,
                                orderID: _angular.$rootScope.token,
                                billingToken: params['ba_token'],
                                payerID: params['PayerID'],
                                paymentID: params['paymentId'] || _this.models.checkoutAppData.payment_id,
                                intent: _this.models.checkoutCart.payment_action
                            };

                            if (_this.models.checkoutAppData.get('urls.return_url')) {
                                xparams.returnUrl = _index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params);
                            }

                            return window.xprops.onAuthorize(xparams);
                        } else if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
                            var redirect = _index.$util.buildURL(_index.$util.param('redirect_uri'));

                            _logger.$logger.info('Nativeapp_Redirection', {
                                redirect: redirect
                            });
                            return handleRedirection(_index.$util.buildURL(redirect, params));
                        } else {
                            return handleRedirection(_index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params));
                        }
                    });
                } else {
                    // PrOX flow only
                    return _angular.$q.when().then(function () {
                        _logger.$logger.info('prox_exit_for_authcode_start');
                        if (_index.$util.param('fromLipp') === 'true') {
                            var lippParamList = {
                                client_id: _index.$util.param('client_id'),
                                scope: _index.$util.param('scope'),
                                state: _index.$util.param('state'),
                                redirect_uri: _index.$util.param('redirect_uri'),
                                metadata_id: _index.$util.param('cart_id')
                            };
                            var lippUrl = _index.$util.buildURL(_angular.$window.location.protocol + '//' + _angular.$window.location.host + _index.$config.urls.lippRedirectUrl, lippParamList);

                            // reroute to LIPP to generate authcode if send from lipp
                            _logger.$logger.info('XOON_REDIRECT_TO_LIPP_FOR_AUTHCODE');
                            return _index8.$ReturnToMerchant.goTo(lippUrl, true);
                        }if (_index.$util.param('ctxId')) {
                            // for UL flow
                            return _index6.$ContextualLoginModel.instance(_angular.$rootScope.token).retrieve().then(function (response) {
                                if (response.success) {
                                    _logger.$logger.info('XOON_REDIRECT_TO_UL_FOR_AUTHCODE');
                                    _logger.$logger.info('checkout_fpti', { from: 'xoon_ul_auth_code', to: 'ul_auth_code' });
                                    var clUrl = _angular.$window.location.protocol + '//' + _angular.$window.location.host + _index.$config.urls.contextualLoginRedirectUrl + _index.$util.param('ctxId');

                                    return _index8.$ReturnToMerchant.goTo(clUrl, true);
                                } else {
                                    _logger.$logger.error('XOON_UNABLE_TO_UPDATE_PAYLOAD_TO_UL_FOR_AUTHCODE');
                                    _logger.$logger.info('checkout_fpti', { from: 'xoon_ul_auth_code', to: 'regular_prox_ul_payload_update_error' });
                                    return finishProxFlow();
                                }
                            });
                        } else {
                            return finishProxFlow();
                        }
                    });
                }
            }); // end of then function
        } // populate

    }

});


_angular.$q;

_angular.$rootScope;

_angular.$window;

_index.$Component;

_index.$config;

_index.$util;

_index.$unresolved;

_index.$integration;

_index2.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_index3.$CheckoutSessionModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index4.$CheckoutInputDataModel;

_index5.$AuthModel;

_index6.$ContextualLoginModel;

_index7.$MerchantPreferenceModel;

_index8.$ReturnToMerchant;

_returnParams.$returnParams;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/directive.js
// module id = ./pages/xo-end/directive.js
// module chunks = 0